/* Copyright 2022 SIB Visions GmbH
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not
 * use this file except in compliance with the License. You may obtain a copy of
 * the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 */

/** Enum for component classnames */
enum COMPONENT_CLASSNAMES {
    PANEL = "Panel",
    DESKTOPPANEL = "DesktopPanel",
    GROUPPANEL = "GroupPanel",
    SCROLLPANEL = "ScrollPanel",
    TOOLBARPANEL = "ToolBarPanel",
    SPLITPANEL = "SplitPanel",
    TABSETPANEL = "TabsetPanel",
    BUTTON = "Button",
    TOGGLEBUTTON = "ToggleButton",
    POPUPMENUBUTTON = "PopupMenuButton",
    RADIOBUTTON = "RadioButton",
    CHECKBOX = "CheckBox",
    LABEL = "Label",
    EDITOR = "Editor",
    TABLE = "Table",
    ICON = "Icon",
    TEXTFIELD = "TextField",
    TEXTAREA = "TextArea",
    PASSWORD = "PasswordField",
    CHART = "Chart",
    GAUGE = "Gauge",
    MAP = "Map",
    TREE = "Tree",
    BROWSER = "MobileBrowser",
    TOOLBAR = "ToolBar",
    TOOLBARHELPERMAIN = "ToolBarHelperMain",
    TOOLBARHELPERCENTER = "ToolBarHelperCenter",
    MOBILELAUNCHER = "Launcher",
    MENUBAR = "MenuBar",
    MENU = "Menu",
    INTERNAL_FRAME = "InternalFrame",
    CUSTOM_CONTAINER = "CustomContainer",
    CUSTOM_COMPONENT = "CustomComponent",
    MENU_ITEM = "MenuItem"
}
export default COMPONENT_CLASSNAMES;